import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from '../../constants/app.constants';
import { CheckChip } from '../../constants/check-chip.constants';
import { isPlatformBrowser } from '@angular/common';

export interface StepCard {
  title?: string;
  text?: string;
  secondaryText?: string;
  link?: string;
  linkRedirect?: string;
  button?: string;
  img?: string;
  background?: string;
}

interface ListItem {
  header: string;
  dots: Array<string>;
}

export interface LocateChip {
  title: string;
  text?: string;
  positioning: string;
  dataBeforeContent: string;
  list?: ListItem;
}

@Component({
  selector: 'app-check-pets-chip',
  templateUrl: './check-pets-chip.component.html',
  styleUrls: ['./check-pets-chip.component.scss'],
})
export class CheckPetsChipComponent implements OnInit {
  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  public nextStepCards: Array<StepCard> = [];
  public locateChipStep: Array<LocateChip> = [];

  public isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.nextStepCards = CheckChip;
  }

  public redirectToZendesk() {
    if (!this.isBrowser) return;
    window.location.href = "https://gbr01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fidentiblog.zendesk.com%2Fhc%2Fen-us%2Farticles%2F24755249274525-Maya-s-Daring-Journey-The-Remarkable-Importance-Of-Microchipping&data=05%7C02%7CVicky%40identicare.pet%7C313fa48c3af84a24120e08dd4b774f3d%7Cf68ebd98d29f49edac2ee589a4bdb782%7C0%7C0%7C638749697996280454%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=G5Crb1bVP6yG3RmqXx9mS4Nr1PiI3BAYd%2Fnciz4qgKI%3D&reserved=0"
  }
}
